import type { CrystallizeImage } from '#shared/types/crystallize'
import type { Document } from '#shared/types/document'
import type { Crystallize } from '#shared/utils/crystallize-spec'

export interface ArticleType extends Document {
  variant: Crystallize.ArticleVariant
  colorTheme: Crystallize.ArticleColorTheme
  thumbnailImage?: CrystallizeImage
  intro?: string
  author?: string | null
  photoCredit?: string | null
  hubspotForm?: string
  body?: string[]
  footer?: string[]
  postCtaBody?: string[]
  extraBox?: string
  footnotes?: string
  podcast?: string
  podcastEpisodes?: Array<Episode>
  inlineCtas?: CTAContent[]
  ctaLicence?: boolean
  ctaContent?: Array<CTAContent>
  showRelatedArticles: boolean
  relatedArticles: Array<ArticleCard>
  accordion?: Array<AccordionContent>
  contentType: 'article'
}

export const CTA_LINKS = [
  'aunivers-barneskole',
  'aunivers-ungdomsskole',
  'produktkatalog',
  'digitalt-supplement',
] as const

export type CtaLink = (typeof CTA_LINKS)[number]

export interface CTAContent {
  title?: string
  content?: string
  link?: string
  label?: string
  links: CtaLink[]
}

export interface AccordionContent {
  groupTitle?: string
  title?: string
  content?: string
  img?: CrystallizeImage
}

export interface ArticleCard extends Identifiable {
  levels: Level[]
  subject?: string[]
  colorTheme: Crystallize.ArticleColorTheme
  slug: Slug
  title: string
  cover?: CrystallizeImage
  thumbnailImage?: CrystallizeImage
  theme?: string[]
}

export interface HighlightedComponentType {
  title?: string
  articles: ArticleCard[]
}
